finderApp.service('productService', ['$http', '$q', 'throttle', 'cacheService', 'accountService', function($http, $q, throttle, cacheService, accountService) {
    "use strict";

    var productService = {
        prepareProduct: function(product) {
            product.background_lazy = finderConfig.imgCdnPath + product.background_lazy;
            product.packshot_lazy = finderConfig.imgCdnPath + product.packshot_lazy;
            product.hasSku = (product.sku != '');
            product.overridePrice = product.override_price;

            product.brand = '';
            product.category = '';

            // Attach the price to item as soon as we get it from other ajax call,
            // so it can be used for items sorting.
            productService.getPrice(product.sku).then(function(price) {
                product.price = price;
            });

            if (product.categories) {
                if(product.categories === 1) {
                    product.category = product.categories[0].title;
                } else if(product.categories > 1) {
                    product.brand = product.categories[0].title;
                    product.category = product.categories[1].title;
                }
            }

            // Each product has unique track_id assigned every time the product list is delivered.
            // Using product.id in "track by" expression caused ng-repeat to cache some DOM elements
            // and prevented onFinishRender directive from firing lazy loading.
            product.track_id = ++finderConfig.track_id_counter;

            return product;
        },

        getPrice: (function() {
            var requestedSkus = [],
                pricePromises = {};

            // Prices are fetched only once per browser tick / frame
            // All skus are collected and then fetched in a combined request
            var fetchPrices = throttle(function(upgradeSkus) {

                var skuList = requestedSkus.join(',');

                requestedSkus.length = 0;

                return $http.get('/', {
                    params: {
                        sku: skuList,
                        upgrades: upgradeSkus.join(','),
                        eID: 'price_v2',
                        list: true,
                        user_country: Util.getCountry()
                    }
                });
            });

            return function(sku) {
                // Don't issue an http request if the sku is empty
                if (!sku || sku === '') {
                    return $q.reject();
                }


                // If the price was already requested by another call just attach to that promise
                if (pricePromises[sku]) {
                    return $q.when(pricePromises[sku]);
                }

                return pricePromises[sku] = accountService.getUpgradeSkus()
                    .then(function(upgradeSkus) {
                        var key = cacheService.generateKey('price', [sku, upgradeSkus]);

                        var cachedPrice = cacheService.get(key);

                        if (cachedPrice !== undefined) {
                            return cachedPrice
                        }

                        // Put the sku onto the queue of skus to fetch
                        requestedSkus.push(sku);

                        return fetchPrices(upgradeSkus)
                            .then(function(response) {
                                var price = response.data[sku];

                                if (price) {
                                    return cacheService.set(key, price, cacheService.parseHttpTtl(response))
                                } else {
                                    console.error('No price found for sku "' + sku + '"');
                                    return $q.reject();
                                }
                            });
                    });
            }
        })(),

        getProducts: function(requestParams) {
            requestParams = angular.copy(requestParams);

            return $http.get(finderConfig.searchUrl, {params: requestParams})
                .then(function(response) {
                    return response.data.hits.map(productService.prepareProduct);
                });
        },

        getReferencePrice: function (product) {

            if (product.overridePrice) {
                return $q.when({
                    personalizedPrice: false,
                    referencePrice: product.overridePrice
                });
            }

            return productService.getPrice(product.sku)
                .then(function (price) {

                    return {
                        personalizedPrice: (price.main && price.main.price_eur) ? price.main.personalized : price.min.personalized,
                        referencePrice: (price.main && price.main.price_eur) ? price.main.price_eur : price.min.price_eur,
                        price: price
                    };

                }, function (price) {

                    return {
                        personalizedPrice: '',
                        referencePrice: '',
                        price: price
                    }

                });
        }

    };

    return productService;
}]);
